import { Library, Loader } from '@googlemaps/js-api-loader';

class GoogleMapsLibrary {
    private readonly loader : Loader;
    private _mapsLibrary: Promise<google.maps.MapsLibrary> | undefined;
    private _geocodingLibrary: Promise<google.maps.GeocodingLibrary> | undefined;
    private _placesLibrary: Promise<google.maps.PlacesLibrary> | undefined;
	
    constructor() {
        this.loader = new Loader({
            apiKey: "AIzaSyDMUpYBzjBC698OdCqPMvehi3VshsYT7Ws",
            version: "quarterly"
        });
    }

    async mapsLibrary() : Promise<google.maps.MapsLibrary> {
        if (this._mapsLibrary) return this._mapsLibrary;

        this._mapsLibrary = this.loadFunction<google.maps.MapsLibrary>("maps");
        return this._mapsLibrary;
    }

    async geocodingLibrary() : Promise<google.maps.GeocodingLibrary> {
        if (this._geocodingLibrary) return this._geocodingLibrary;

        this._geocodingLibrary = this.loadFunction<google.maps.GeocodingLibrary>("geocoding");
        return this._geocodingLibrary;
    }


    async placesLibrary() : Promise<google.maps.PlacesLibrary> {
        if (this._placesLibrary) return this._placesLibrary;

        this._placesLibrary = this.loadFunction<google.maps.PlacesLibrary>("places");
        return this._placesLibrary;
    }

    async loadFunction<T>(libraryName: Library) : Promise<T> {
        await this.loader.importLibrary(libraryName)
        return await google.maps.importLibrary(libraryName) as unknown as T;
    }
}

const instance = new GoogleMapsLibrary();

export { instance as GoogleMapsLibrary }